var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPrint = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9102,
    cy: 19.108,
    r: 19,
    fill: "#ACCE42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9844 15.58H28.2684C28.6464 15.58 28.9404 15.874 28.9404 16.252V24.736C28.9404 25.114 28.6464 25.408 28.2684 25.408H25.3284",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4909 25.408H11.5509C11.1729 25.408 10.8789 25.114 10.8789 24.736V16.252C10.8789 15.874 11.1729 15.58 11.5509 15.58H20.5474",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1363 28.7256H15.6844C15.3071 28.7256 15.043 28.3717 15.043 27.9736V22.002C15.043 21.5596 15.3448 21.25 15.6844 21.25H24.1363C24.5136 21.25 24.7778 21.6039 24.7778 22.002V27.9736C24.7778 28.3717 24.5136 28.7256 24.1363 28.7256Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 21.25H26.4619",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4922 15.58V10.33C14.4922 9.95196 14.7862 9.65796 15.1642 9.65796H24.6982C25.0762 9.65796 25.3702 9.95196 25.3702 10.33V15.58",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 0.107971H38.9102V38.108H0.910156V0.107971Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.41016,
    y: 8.60797,
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Print.39659d66.svg";
export { ForwardRef as ReactComponent };